import Booking from 'mfBooking/Booking';
import { useGateway } from '@ad-lucy/gateway-provider';
import { useNavigate } from 'react-router-dom';
import { bookingApiConfig } from '../../../remotes/booking/bookingApiConfig';
import type { IBookingIntegrated } from './BookingIntegrated.types';

export function BookingIntegrated({
  mode,
  campaignId,
}: Readonly<IBookingIntegrated>) {
  const navigate = useNavigate();
  const gateway = useGateway();

  // Ensure TypeScript enforces the required `campaignId` for 'FRANCHISE' mode
  if (mode === 'FRANCHISE' && !campaignId) {
    throw new Error('campaignId is required for FRANCHISE mode');
  }

  return (
    <Booking
      gateway={gateway}
      apiConfig={bookingApiConfig()}
      mode={mode}
      onNavigate={(route: string) => navigate(route)}
      campaignId={campaignId}
    />
  );
}
